import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import * as Store from '../../store';
import * as Logger from 'js-logger';
import template from './header.vue';
import $ from 'jquery';

@Component({
    mixins: [template],
})

export default class Header extends Vue {

    created() {
        // When the component gets created.
    }

    mounted() {

    }

    get isLoggedIn(): boolean {
        return Store.readLoggedInState(this.$store);
    }

    doLogout() {
        localStorage.removeItem('hud');
        Store.commitLoggedInState(this.$store, false);
        Store.commitLoggedInUser(this.$store, {});
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/header/index.ts